export enum BookLanguage {
    German = 1,
    English = 2,
    Other = 3,
    WithoutText = 4,
}
